import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Permission } from '../../pages/roles/permission';
import { CashShiftService } from '../../pages/cash-shift/cash-shift.service';
import { hasCashShiftCanAdd } from '../utils/permission.util';

@Injectable({ providedIn: 'root' })
export class CashShiftNavigationService {
  constructor(private cashShiftService: CashShiftService) {}

  public resolvePostLoginRoute(permissions: Permission[] | undefined): Observable<string> {
    if (!hasCashShiftCanAdd(permissions)) {
      return of('/profile');
    }

    return this.cashShiftService.getCurrent().pipe(
      map((response) => (response.data?.isOpen ? '/profile' : '/orders?cashShift=1')),
      catchError(() => of('/profile'))
    );
  }
}
